import { render, staticRenderFns } from "./faq-btn-share.vue?vue&type=template&id=21bed402&"
import script from "./faq-btn-share.vue?vue&type=script&lang=js&"
export * from "./faq-btn-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./faq-btn-share-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Fgeneral%2Ffaq%2Ffaq-btn-share.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports